import { IEventItem } from '../../store/player/events/store';

export const getEnrollmentsIdsInEventTeesheet = (event: IEventItem) =>
  event.rounds
    .flatMap(round => round.groups.flatMap(group => group.enrollments))
    .map(enrollment => enrollment.id);
